const BlueGradient = ({ className }: { className?: string }) => {
  return (
    <div 
      className={`w-375 h-225 sm:w-605 sm:h-412.5 -z-20 gradient ${className}`}
      style={{ transform: 'translateZ(0)', willChange: 'filter' }}
    ></div>
  );
};
const WhiteGradient = ({ className }: { className?: string }) => {
  return (
    <div 
      className={`w-[70vw] h-[60vh] sm:w-288.5 sm:h-183 -z-30 absolute top-0 right-0 sm:-right-10 gradient-white  ${className} `}
      style={{ transform: 'translateZ(0)', willChange: 'filter' }}
    ></div>
  );
};
const LightBLueGradient = ({ className }: { className?: string }) => {
  return (
    <div 
      className={`w-[80vw] h-[70vh] sm:w-260.75 sm:h-256 -z-20 absolute top-0 left-0 sm:-left-20 bg-[#075480] gradient-light-blue  ${className} `}
      style={{ transform: 'translateZ(0)', willChange: 'filter' }}
    ></div>
  );
};

export const Gradients = () => {
  return (
    <div className="w-full -z-40 absolute top-0 left-0 flex flex-col justify-center items-center">
      <div className="relative w-full h-screen">
        <LightBLueGradient/>
        <WhiteGradient/>
      </div>

      <BlueGradient />
      <BlueGradient className="mt-30 ml-150 sm:block hidden" />
      <BlueGradient className="sm:block hidden" />
    </div>
  );
};
